export interface Province {
    provinceName: string;
    provinceId: number;
}

export const provinces: Province[] = [
    {
        provinceName: "اردبيل",
        provinceId: 24,
    },
    {
        provinceName: "اصفهان",
        provinceId: 10,
    },
    {
        provinceName: "البرز",
        provinceId: 30,
    },
    {
        provinceName: "ايلام",
        provinceId: 16,
    },
    {
        provinceName: "آذربايجان شرقی",
        provinceId: 3,
    },
    {
        provinceName: "آذربايجان غربی",
        provinceId: 4,
    },
    {
        provinceName: "بوشهر",
        provinceId: 18,
    },
    {
        provinceName: "تهران",
        provinceId: 23,
    },
    {
        provinceName: "چهارمحال وبختياری",
        provinceId: 14,
    },
    {
        provinceName: "خراسان جنوبی",
        provinceId: 29,
    },
    {
        provinceName: "خراسان رضوی",
        provinceId: 9,
    },
    {
        provinceName: "خراسان شمالی",
        provinceId: 28,
    },
    {
        provinceName: "خوزستان",
        provinceId: 6,
    },
    {
        provinceName: "زنجان",
        provinceId: 19,
    },
    {
        provinceName: "سمنان",
        provinceId: 20,
    },
    {
        provinceName: "سيستان وبلوچستان",
        provinceId: 11,
    },
    {
        provinceName: "فارس",
        provinceId: 7,
    },
    {
        provinceName: "قزوين",
        provinceId: 26,
    },
    {
        provinceName: "قم",
        provinceId: 25,
    },
    {
        provinceName: "كردستان",
        provinceId: 12,
    },
    {
        provinceName: "كرمان",
        provinceId: 8,
    },
    {
        provinceName: "كهگيلويه وبويراحمد",
        provinceId: 17,
    },
    {
        provinceName: "کرمانشاه",
        provinceId: 5,
    },
    {
        provinceName: "گلستان",
        provinceId: 27,
    },
    {
        provinceName: "گيلان",
        provinceId: 1,
    },
    {
        provinceName: "لرستان",
        provinceId: 15,
    },
    {
        provinceName: "مازندران",
        provinceId: 2,
    },
    {
        provinceName: "مرکزی",
        provinceId: 0,
    },
    {
        provinceName: "هرمزگان",
        provinceId: 22,
    },
    {
        provinceName: "همدان",
        provinceId: 13,
    },
    {
        provinceName: "يزد",
        provinceId: 21,
    },
];
